
import React from "react"

interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: number;
  className?: string;
  color?: 'green' | 'yellow' | 'orange' | 'red' | 'default';
}

const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ className = "", value, color = 'default', ...props }, ref) => {
    const getBarColor = () => {
      switch (color) {
        case 'green':
          return 'bg-green-600';
        case 'yellow':
          return 'bg-yellow-500';
        case 'orange':
          return 'bg-orange-500';
        case 'red':
          return 'bg-red-600';
        default:
          return 'bg-blue-600';
      }
    };

    const getBackgroundColor = () => {
      switch (color) {
        case 'green':
          return 'bg-green-100 border border-green-200';
        case 'yellow':
          return 'bg-yellow-100 border border-yellow-200';
        case 'orange':
          return 'bg-orange-100 border border-orange-200';
        case 'red':
          return 'bg-red-100 border border-red-200';
        default:
          return 'bg-gray-200 border border-gray-300';
      }
    };

    return (
      <div
         ref={ref}
         className={`relative h-4 w-full overflow-hidden rounded-full ${getBackgroundColor()} ${className}`}
         {...props}
       >
        <div
          className={`h-full transition-all ${getBarColor()}`}
          style={{ width: `${Math.min(Math.max(value || 0, 0), 100)}%` }}
        />
      </div>
    );
  }
)
Progress.displayName = "Progress"

export { Progress }
